__webpack_require__.p = "/pokepedia/";